import { UserSubscriptionTransaction } from "@/domain/entities/UserSubscriptionTransaction"
import { IUserRepository } from "@/domain/repositories/IUserRepository"
import { IListUserSubscriptionHistoryUseCase } from "@/domain/usecases/IListUserSubscriptionHistoryUseCase"

export class ListUserSubscriptionHistoryUseCase implements IListUserSubscriptionHistoryUseCase {
    repository: IUserRepository
    constructor(repository: IUserRepository) {
        this.repository = repository
    }

    execute(userId: string): Promise<UserSubscriptionTransaction[]> {
        return this.repository.listSubscriptionHistory(userId)
    }
}
